// eslint-disable-next-line import/prefer-default-export
export enum StatusDoProtocoloEnum {
  segueOProtocolo = 'SegueOProtocolo',
  naoSegueOProtocolo = 'NaoSegueOProtocolo',
  temProtocoloDisponivel = 'TemProtocoloDisponivel',
  fidelizacaoAceitouJustificativaMedico = 'FidelizacaoAceitouJustificativaMedico'
}
